import { Card } from "@mui/material";
import FullScreenSpinner from "src/components/Spinner/FullScreenSpinner";
import { useApiQuery } from "src/hooks/useApiQuery";
import { IPayableItem } from "src/Types/module/paymentableItem/itemList";
import PayableItemTable from "./PaymentableItemTable";

const PayableItemShow = () => {
	const { data: payableItems = [], isLoading } = useApiQuery<IPayableItem[]>({
		endPoint: `/api/admin/payment-items`,
		queryKeys: ["PayableItems"],
		params: {},
	});

	if (isLoading) {
		return <FullScreenSpinner />;
	}

	return (
		<Card>
			<PayableItemTable
				payableItems={payableItems}
				isLoading={isLoading}
			/>
		</Card>
	);
};

export default PayableItemShow;
